import { hasNonDigitCharacters } from '../helpers/index.js';

var INVALID_CHARACTERS_ERROR_MESSAGE = 'СНИЛС может состоять только из цифр';
var INVALID_LENGTH_ERROR_MESSAGE = 'СНИЛС состоит из 11 цифр';
/**
 * Валидные значения по контрольной сумме, но не в жизни.
 */

var snilsExcepts = ['00000000000', '00000000101'];
var validSnils = function (message) {
  if (message === void 0) {
    message = 'Введите корректный СНИЛС';
  }

  return function (value) {
    if (!value) {
      return message;
    }

    if (hasNonDigitCharacters(value)) {
      return INVALID_CHARACTERS_ERROR_MESSAGE;
    }

    if (value.length !== 11) {
      return INVALID_LENGTH_ERROR_MESSAGE;
    }

    if (snilsExcepts.includes(value)) {
      return message;
    }

    var baseNumber = value.substring(0, 9);

    if (Number.parseInt(baseNumber, 10) === 0) {
      return message;
    }

    var numbers = baseNumber.split('');
    var code = value.substring(9);
    var sum = numbers.reduce(function (acc, num, index) {
      acc += Number.parseInt(num, 10) * (9 - index);
      return acc;
    }, 0);

    if (sum > 101) {
      sum = sum % 101;
    }

    var checkSum;

    if (sum < 100) {
      checkSum = sum;
    } else if (sum === 100 || sum === 101) {
      checkSum = 0;
    }

    if (Number.parseInt(code, 10) === checkSum) {
      return;
    }

    return message;
  };
};

export default validSnils;
export { INVALID_CHARACTERS_ERROR_MESSAGE, INVALID_LENGTH_ERROR_MESSAGE, validSnils };
